"use client";

import { usePathname } from "next/navigation";
import Link from "next/link";
import { ChevronRight } from "lucide-react";
import { Fragment } from "react";

const LABELS: Record<string, string> = {
  "": "Inicio",
  documents: "Documentos",
  spaces: "Proyectos",
  tasks: "Tareas",
  meetings: "Reuniones",
  users: "Miembros",
  groups: "Grupos",
  notifications: "Notificaciones",
  search: "Búsqueda",
  templates: "Plantillas",
  admin: "Administración",
  settings: "Configuración",
  graph: "Grafo",
  dashboard: "Dashboard",
  workflows: "Workflows",
  publications: "Publicaciones",
  properties: "Propiedades",
  health: "Salud",
  attachments: "Adjuntos",
  ai: "Asistente IA",
};

/**
 * Breadcrumb automático basado en el pathname.
 * Mapea segmentos a labels legibles y los enlaza en cascada.
 * El último segmento no es clickeable.
 */
export function Breadcrumbs() {
  const pathname = usePathname();
  const segments = pathname.split("/").filter(Boolean);

  // Si estamos en /workspace, no mostrar nada (es la raíz del workspace)
  if (segments.length <= 1) return null;

  const crumbs: { label: string; href: string }[] = [];
  let acc = "";
  for (const seg of segments) {
    acc += `/${seg}`;
    const label = LABELS[seg] ?? seg;
    crumbs.push({ label, href: acc });
  }

  return (
    <nav
      aria-label="Breadcrumb"
      className="flex items-center gap-1.5 text-[11px] text-muted-foreground/80 select-none"
    >
      {crumbs.map((c, i) => {
        const isLast = i === crumbs.length - 1;
        return (
          <Fragment key={c.href}>
            {i > 0 && <ChevronRight className="w-3 h-3 text-muted-foreground/40 shrink-0" aria-hidden="true" />}
            {isLast ? (
              <span className="text-foreground/90 font-medium truncate" aria-current="page">
                {c.label}
              </span>
            ) : (
              <Link
                href={c.href}
                className="hover:text-foreground transition-colors truncate"
              >
                {c.label}
              </Link>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}
